// extracted by mini-css-extract-plugin
export var fallback = "_a-0";
export var icon = "_a-1";